export default __webpack_public_path__ + "static/media/IMG_98912.98dd957e.jpg";